import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {isEmpty} from 'lodash/lang';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {clearFlashMessage} from 'actions/flash-message';
import MySnackbarContentWrapper from './common/SnackbarContentWrapper';


class FlashMessage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
        this.handleClose = this.handleClose.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const {flashMessage} = nextProps;
        if (!isEmpty(flashMessage.msgType) && !isEmpty(flashMessage.message)) {
            this.setState({
                open: true,
            });
        }
    }

    handleClose() {
        this.setState({
            open: false,
        });
    }

    render() {
        const {flashMessage} = this.props;
        const {open} = this.state;
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={open}
                autoHideDuration={5000}
                onClose={this.handleClose}
                action={
                    <IconButton
                        onClick={this.handleClose}
                        color="inherit">
                        <CloseIcon/>
                    </IconButton>
                }
            >
                <MySnackbarContentWrapper
                    variant={flashMessage.msgType ? flashMessage.msgType : 'info'}
                    onClose={this.handleClose}
                    message={flashMessage.message}/>
            </Snackbar>
        );
    }
}

FlashMessage.propTypes = {
    flashMessage: PropTypes.object.isRequired,
    clearFlashMessage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    flashMessage: state.flashMessage,
});

const mapDispatchToProps = (dispatch) => ({
    clearFlashMessage: () => dispatch(clearFlashMessage()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FlashMessage);
